import { Button } from '@/components/ui/button';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';

function getErrorMessage(error: unknown) {
  if (isRouteErrorResponse(error)) {
    return `${error.status} ${error.statusText}`.trim();
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'Something unexpected happened.';
}

export function AppErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  const showDetails = import.meta.env.DEV;
  const { t } = useTranslation('errors');
  const handleReload = useCallback(() => {
    navigate(0);
  }, [navigate]);

  const handleHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-2xl font-semibold">{t('errorBoundary.title')}</h1>
      <p className="text-muted-foreground max-w-md text-base">
        {showDetails
          ? getErrorMessage(error)
          : t('errorBoundary.contactSupport')}
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button variant="secondary" onClick={handleReload}>
          {t('errorBoundary.tryAgain')}
        </Button>
        <Button onClick={handleHome}>{t('errorBoundary.backHome')}</Button>
      </div>
    </div>
  );
}
